import { DataBean } from "../DataBean";

export class CashRequestItemBystate extends DataBean {


    public async getCashRequestItemCatalogByState(year:any,idAccount:any,idCashDeskAccount:any,state:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getCashRequestItemCatalogByState_Number_Number_Number_Number_Number_Number", [year,idAccount,idCashDeskAccount,state,page,recordsPerPage]);
    }

}